import { render, staticRenderFns } from "./listados.vue?vue&type=template&id=8430a9b2"
import script from "./listados.vue?vue&type=script&lang=js"
export * from "./listados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports